"use client";
import * as React from "react";
import { NextUIProvider } from "@nextui-org/system";
import { ThemeProvider  } from "next-themes";
import { ThemeProviderProps } from "next-themes/dist/types";
import {useRouter} from 'next/navigation';
import { SnackbarProvider } from 'notistack';

export interface ProvidersProps {
	children: React.ReactNode;
	themeProps?: ThemeProviderProps;
}

export function Providers({ children, themeProps }: ProvidersProps) {
	const router = useRouter();

	return (		
		<React.StrictMode>
			<NextUIProvider navigate={router.push}>
				<ThemeProvider {...themeProps} attribute="class">
					<SnackbarProvider>
						{children}
					</SnackbarProvider>
				</ThemeProvider>
			</NextUIProvider>
		</React.StrictMode>
	);
}
